import type { CardListItem, CardSummary } from "@hobbyshopify/backend-client";

/** The count a row shows: what was tapped and not yet sent, else what the shop can sell. */
export function displayedAvailable(card: CardListItem["card"], edits: Readonly<Record<string, number>>): number {
  return edits[card.id] ?? card.available;
}

/**
 * What a row's stock change sends: the copies on hand, moved by what was tapped
 * over what could be sold. A stock change sets the total on hand, and the row
 * shows what can be sold, so sending the row's own figure would drop the copies
 * held for open quotes.
 */
export function onHandFor(card: Pick<CardSummary, "onHand" | "available">, target: number): number {
  return card.onHand + (target - card.available);
}

/**
 * Tracked cards on the list, priced at what the shop asks. Null while more pages
 * exist: a sum of whatever happens to be loaded is not the stock's value.
 */
export function stockValueCents(
  items: readonly CardListItem[],
  edits: Readonly<Record<string, number>>,
  complete: boolean,
): number | null {
  if (!complete) return null;
  return items.reduce((total, { card }) => {
    if (!card.trackStock || card.currentPriceCents == null) return total;
    return total + card.currentPriceCents * displayedAvailable(card, edits);
  }, 0);
}

/** What a count changed on the list is recorded as, as iOS records it. */
export const STOCK_LIST_REASON = "Counted on the stock list";
